<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">セット企画設定</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="block-column">
          <div class="element-column">
            <div class="block-row">
              <div class="column-list">
                <label class="list-input-title">プロモーションNO</label>
                <div class="list-input-content">
                  <select style="width:197px" [tabindex]="0" id="cmb_PromotionNo" [autofocus]="true" #cmb_PromotionNo
                    forcedEnabledMode="true" [(ngModel)]="KYMW1312Model.promotionNo" (change)="eventNo_CHANGEHandler($event)">
                    <ng-template ngFor let-item [ngForOf]="KYMW1312Model.promotionNoList" let-i="index">
                      <option value="{{item}}">{{item}}</option>
                    </ng-template>
                  </select>
                </div>
              </div>

              <div class="column-list">
                <label class="list-input-title">プロモーション名称</label>
                <div class="list-input-content">
                  <app-text-input id="txt_PromotionName" class="list-input-content" #txt_PromotionName [subid]="'txt_PromotionName'"
                    [(ngModel)]="KYMW1312Model.promotionName" [restrict]="'[ -￮]'" [maxChars]="20" [fullOnly]="true"
                    [disabled]="KYMW1312Model.disabledPromotionName" [displayCountField]="false" style="width:21rem;"
                    (change)="eventEditHandler($event)" [tabindex]="0">
                  </app-text-input>
                </div>
              </div>

              <button id="btn_Search" class='btn-secondary' forcedEnabledMode="true"
                (click)="eventSearch_CLICKHandler($event)" [tabindex]="0">セット企画検索</button>
            </div>

            <div class="column-list">
              <label class="list-input-title">プロモーション区分</label>
              <div class="list-input-content">
                <app-radio-label #rbt_SetPlan groupName="grp_PromotionDiv" [tabindex]="0" value="S" id="rbt_SetPlan"
                  [subid]="'rbt_SetPlan'" label="セット企画" [(ngModel)]="KYMW1312Model.promotionDiv"
                  [disabled]="true"></app-radio-label>
                  <div id="grp_PromotionDiv" selectedValue="S"></div>
              </div>
            </div>
          </div>

          <div>
            <h2>設定値一括反映</h2>
            <div class="element-column">
              <div class="column-list">
                <label class="list-input-title">設定単位</label>
                <div class="list-input-content">
                  <app-radio-label #rbt_UnitAll name="grp_SetUnit" [tabindex]="0" value="1" id="rbt_UnitAll"
                    [subid]="'rbt_UnitAll'" label="全生協" [(ngModel)]="KYMW1312Model.setUnit"
                    [disabled]="KYMW1312Model.disabledUnitAll" (change)="eventUnit_CHANGEHandler($event)"></app-radio-label>
                  <app-radio-label #rbt_UnitCoop name="grp_SetUnit" [tabindex]="0" value="2" id="rbt_UnitCoop"
                    [subid]="'rbt_UnitCoop'" label="生協単位" [(ngModel)]="KYMW1312Model.setUnit"
                    [disabled]="KYMW1312Model.disabledUnitCoop"
                    (change)="eventUnit_CHANGEHandler($event)"></app-radio-label>
                  <div id="grp_SetUnit"></div>
                </div>
              
                <label class="list-input-title">生協選択</label>
                <div class="list-input-content">
                  <app-checkbox-label #chk_CoopIB id="chk_CoopIB" [subid]="'chk_CoopIB'" label="い" [tabindex]="0"
                    [(ngModel)]="KYMW1312Model.coopIB" [disabled]="KYMW1312Model.disabledCoopIB">
                  </app-checkbox-label>
                  <app-checkbox-label #chk_CoopTO id="chk_CoopTO" [subid]="'chk_CoopTO'" label="と" [tabindex]="0"
                    [(ngModel)]="KYMW1312Model.coopTO" [disabled]="KYMW1312Model.disabledCoopTO">
                  </app-checkbox-label>
                  <app-checkbox-label #chk_CoopGU id="chk_CoopGU" [subid]="'chk_CoopGU'" label="ぐ" [tabindex]="0"
                    [(ngModel)]="KYMW1312Model.coopGU" [disabled]="KYMW1312Model.disabledCoopGU">
                  </app-checkbox-label>
                  <app-checkbox-label #chk_CoopTI id="chk_CoopTI" [subid]="'chk_CoopTI'" label="ち" [tabindex]="0"
                    [(ngModel)]="KYMW1312Model.coopTI" [disabled]="KYMW1312Model.disabledCoopTI">
                  </app-checkbox-label>
                  <app-checkbox-label #chk_CoopSA id="chk_CoopSA" [subid]="'chk_CoopSA'" label="さ" [tabindex]="0"
                    [(ngModel)]="KYMW1312Model.coopSA" [disabled]="KYMW1312Model.disabledCoopSA">
                  </app-checkbox-label>
                  <app-checkbox-label #chk_CoopTK id="chk_CoopTK" [subid]="'chk_CoopTK'" label="とう" [tabindex]="0"
                    [(ngModel)]="KYMW1312Model.coopTK" [disabled]="KYMW1312Model.disabledCoopTK">
                  </app-checkbox-label>
                  <app-checkbox-label #chk_CoopNA id="chk_CoopNA" [subid]="'chk_CoopNA'" label="な" [tabindex]="0"
                    [(ngModel)]="KYMW1312Model.coopNA" [disabled]="KYMW1312Model.disabledCoopNA">
                  </app-checkbox-label>
                  <app-checkbox-label #chk_CoopNI id="chk_CoopNI" [subid]="'chk_CoopNI'" label="に" [tabindex]="0"
                    [(ngModel)]="KYMW1312Model.coopNI" [disabled]="KYMW1312Model.disabledCoopNI">
                  </app-checkbox-label>
                  <app-checkbox-label #chk_CoopKU id="chk_CoopKU" [subid]="'chk_CoopKU'" label="ク" [tabindex]="0"
                    [(ngModel)]="KYMW1312Model.coopKU" [disabled]="KYMW1312Model.disabledCoopKU">
                  </app-checkbox-label>
                </div>
              </div>
              
              <div class="block-row">
                <div class="column-list">
                  <label class="list-input-title">セット企画数量</label>
                  <input type="text" [tabindex]="0" id="txt_ApprovedNum" class="list-input-content" #txt_ApprovedNum
                    plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="KYMW1312Model.approvedNum"
                    [disabled]="KYMW1312Model.disabledApprovedNum" style="width:3rem;"/>
                </div>

                <div class="column-list">
                  <label class="list-input-title">成立価格</label>
                  <input type="text" [tabindex]="0" id="txt_ApprovedPrice" class="list-input-content" #txt_ApprovedPrice
                    plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6" [(ngModel)]="KYMW1312Model.approvedPrice"
                    [disabled]="KYMW1312Model.disabledApprovedPrice" style="width:6rem;"/>
                </div>
              </div>
              
              <button #btn_Reflection [tabindex]="0" class='btn-secondary' id="btn_Reflection"
                (click)="eventReflection_CLICKHandler($event)" [disabled]="KYMW1312Model.disabledReflection">一括反映</button>
            </div>
          </div>

          <div>
            <div class="layout_balance">
              <h2>プロモーション情報</h2>
              <div>
                <button id="btn_DelRow" class='btn-tartiary warning' [disabled]="KYMW1312Model.disabledDelRow"
                  (click)="eventDelRow_CLICKHandler($event)" [tabindex]="0">行削除</button>
                <button id="btn_DelAll" class='btn-tartiary warning' [disabled]="KYMW1312Model.disabledDelAll"
                  (click)="eventDelAll_CLICKHandler($event)" [tabindex]="0">全削除</button>
              </div>
            </div>

            <wj-flex-grid #dtg_PromotionInfo [style.width.px]="1048" [style.height.px]="400" editable="false"
              [headersVisibility]="'Column'" [frozenColumns]="3" id="dtg_PromotionInfo" [allowDragging]="'None'"
              [tabindex]="-1" [itemsSource]="KYMW1312Model.promotionInfo" (pasting)="onPasting($event)">

              <wj-flex-grid-column [minWidth]="5" editable="false" [width]="90" [header]="'Ｐコード'" id="col_PCode"
                [binding]="'pCode'" [isReadOnly]="true"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" editable="false" [width]="185" [header]="'商品名'" id="col_GuideGoodsName"
                [binding]="'guideGoodsName'" [isReadOnly]="true"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" editable="false" [width]="132" [header]="'規格名'"
                id="col_GuideStandardName" [binding]="'guideStandardName'" [isReadOnly]="true"></wj-flex-grid-column>

              <wj-flex-grid-column [minWidth]="5" [width]="146" [header]="'セット企画\n商品名\n'" id="col_SetDelivGoodsName"
                [binding]="'setDelivGoodsName'" [multiLine]="true" [style.width.%]="'100'">
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" [maxlength]="15" plessInputTextSub [fullOnly]="true" [(ngModel)]="cell.value"
                    #txt_setDelivGoodsName (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 3)"
                    [disabled]="cell.item.setPlanDiv === KYMW1312Model.SET_PLAN_DIV_PARENT.data" [tabindex]="0" 
                    [restrict]="'[ -￮]'"/>
                </ng-template>
              </wj-flex-grid-column>

              <wj-flex-grid-column [minWidth]="5" [width]="126" [header]="'セット企画\n商品名\n（カナ）'"
                id="col_SetDelivGoodsNameKana" [binding]="'setDelivGoodsNameKana'" [multiLine]="true"
                [style.width.%]="'100'">
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" [maxlength]="15" plessInputTextSub [halfOnly]="true" [(ngModel)]="cell.value"
                    #txt_setDelivGoodsNameKana (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 4)"
                    [disabled]="cell.item.setPlanDiv === KYMW1312Model.SET_PLAN_DIV_PARENT.data" [tabindex]="0"
                    (blur)="deleteCommaHandler(cell)" [toUpperCase]="true"/>
                </ng-template>
              </wj-flex-grid-column>

              <wj-flex-grid-column [minWidth]="5" [width]="106" [header]="'セット企画\n規格名\n'" id="col_SetDelivStandardName"
                [binding]="'setDelivStandardName'" [multiLine]="true" [style.width.%]="'100'">
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" [maxlength]="10" plessInputTextSub [fullOnly]="true" [(ngModel)]="cell.value"
                    #txt_setDelivStandardName (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 5)"
                    [disabled]="cell.item.setPlanDiv === KYMW1312Model.SET_PLAN_DIV_PARENT.data" [tabindex]="0" 
                    [restrict]="'[ -￮]'"/>
                </ng-template>
              </wj-flex-grid-column>

              <wj-flex-grid-column [minWidth]="5" [width]="94" [header]="'セット企画\n規格名\n（カナ）'"
                id="col_SetDelivStandardNameKana" [binding]="'setDelivStandardNameKana'" [multiLine]="true"
                [style.width.%]="'100'">
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" [maxlength]="10" plessInputTextSub [halfOnly]="true" [(ngModel)]="cell.value"
                    #txt_setDelivStandardNameKana (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 6)"
                    [disabled]="cell.item.setPlanDiv === KYMW1312Model.SET_PLAN_DIV_PARENT.data" [tabindex]="0"
                    (blur)="deleteCommaHandler(cell)" [toUpperCase]="true"/>
                </ng-template>
              </wj-flex-grid-column>

              <wj-flex-grid-column [minWidth]="5" [header]="'セット企画\n\n区分'" [binding]="'setPlanDiv'" [width]="82"
                id="cmb_SetPlanDiv" resizable="true" [multiLine]="true" [isReadOnly]="true">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <select [style.left.px]="0" [style.top.px]="0" [style.width.%]="100" [(ngModel)]="cell.item.setPlanDiv"
                    (change)="eventSetPlanDiv_CHANGEHandler()"
                    [disabled]="!KYMW1312Model.editLock || (cell.item.setPlanDiv === KYMW1312Model.SET_PLAN_DIV_PARENT.data)">
                    <ng-template ngFor let-item [ngForOf]="KYMW1312Model.setPlanDivList" let-i="index">
                      <option value="{{item.data}}">{{item.label}}</option>
                    </ng-template>
                  </select>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'単品注文\n\n可否区分'" [binding]="'singleOrderFlag'" [width]="104"
                id="cb_SingleOrderFlag" resizable="true" [multiLine]="true" [isReadOnly]="true">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <select [style.left.px]="0" [style.top.px]="0" [style.width.%]="100"
                    [(ngModel)]="cell.item.singleOrderFlag" (change)="eventSingleOrderFlag_CHANGEHandler($event)"
                    [disabled]="!KYMW1312Model.editLock || (cell.item.setPlanDiv === KYMW1312Model.SET_PLAN_DIV_PARENT.data)">
                    <ng-template ngFor let-item [ngForOf]="KYMW1312Model.singleOrderFlagList" let-i="index">
                      <option value="{{item.data}}">{{item.label}}</option>
                    </ng-template>
                  </select>
                </ng-template>
              </wj-flex-grid-column>

              <wj-flex-grid-column [minWidth]="5" [width]="75" id="col_SupplyPiceIB" [binding]="'thisTimeSupplyPriceIB'"
                [header]="'供給価格\n\nいばらき'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceIB">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="75" id="col_thisTimeCostPriceIB" [align]="'right'"
                [binding]="'thisTimeCostPriceIB'" [header]="'仕入価格\n\nいばらき'" [multiLine]="true" [isReadOnly]="true">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceIB">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumIB" [binding]="'approvedNumIB'"
                [header]="'セット企画数量\n\nいばらき'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                  <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumIB"></app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3" #txt_approvedNumIB
                    [style.width.%]="'100'" [style.text-align]="'right'" autocomplete="off" [(ngModel)]="cell.value"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 11)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgIB === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="75" id="col_ApprovedPriceIB" [binding]="'approvedPriceIB'"
                [header]="'成立価格\n\nいばらき'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceIB">
                  </app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" #txt_approvedPriceIB [(ngModel)]="cell.value" [maxlength]="6" autocomplete="off"
                    [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub [restrict]="'[0-9]'"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 12)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgIB === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [isReadOnly]="true" [width]="100" id="col_DeliveryLeadTimeTypeIB"
                [binding]="'deliveryLeadTimeTypeNameIB'" [header]="'配達リード\n区分\nいばらき'" [multiLine]="true">
              </wj-flex-grid-column>

              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_SupplyPiceTO" [binding]="'thisTimeSupplyPriceTO'"
                [header]="'供給価格\n\nとちぎ'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceTO">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_thisTimeCostPriceTO"
                [binding]="'thisTimeCostPriceTO'" [header]="'仕入価格\n\nとちぎ'" [multiLine]="true" [isReadOnly]="true"
                [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceTO">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumTO" [binding]="'approvedNumTO'"
                [header]="'セット企画数量\n\nとちぎ'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                  <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumTO"></app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3" #txt_approvedNumTO
                    [style.width.%]="'100'" [style.text-align]="'right'" autocomplete="off" [(ngModel)]="cell.value"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 16)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgTO === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_ApprovedPriceTO" [binding]="'approvedPriceTO'"
                [header]="'成立価格\n\nとちぎ'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceTO">
                  </app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" #txt_approvedPriceTO [(ngModel)]="cell.value" [maxlength]="6" autocomplete="off"
                    [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub [restrict]="'[0-9]'"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 17)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgTO === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [isReadOnly]="true" [width]="100" id="col_DeliveryLeadTimeTypeTO"
                [binding]="'deliveryLeadTimeTypeNameTO'" [header]="'配達リード\n区分\nとちぎ'" [multiLine]="true">
              </wj-flex-grid-column>

              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_SupplyPiceGU" [binding]="'thisTimeSupplyPriceGU'"
                [header]="'供給価格\n\nぐんま'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceGU">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_thisTimeCostPriceGU"
                [binding]="'thisTimeCostPriceGU'" [header]="'仕入価格\n\nぐんま'" [multiLine]="true" [isReadOnly]="true"
                [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceGU">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumGU" [binding]="'approvedNumGU'"
                [header]="'セット企画数量\n\nぐんま'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                  <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumGU"></app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3" #txt_approvedNumGU
                    [style.width.%]="'100'" [style.text-align]="'right'" autocomplete="off" [(ngModel)]="cell.value"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 21)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgGU === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_ApprovedPriceGU" [binding]="'approvedPriceGU'"
                [header]="'成立価格\n\nぐんま'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceGU">
                  </app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" #txt_approvedPriceGU [(ngModel)]="cell.value" [maxlength]="6" autocomplete="off"
                    [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub [restrict]="'[0-9]'"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 22)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgGU === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [isReadOnly]="true" [width]="100" id="col_DeliveryLeadTimeTypeGU"
                [binding]="'deliveryLeadTimeTypeNameGU'" [header]="'配達リード\n区分\nぐんま'" [multiLine]="true">
              </wj-flex-grid-column>

              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_SupplyPiceTI" [binding]="'thisTimeSupplyPriceTI'"
                [header]="'供給価格\n\nちば'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceTI">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_thisTimeCostPriceTI"
                [binding]="'thisTimeCostPriceTI'" [header]="'仕入価格\n\nちば'" [multiLine]="true" [isReadOnly]="true"
                [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceTI">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumTI" [binding]="'approvedNumTI'"
                [header]="'セット企画数量\n\nちば'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                  <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumTI"></app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3" #txt_approvedNumTI
                    [style.width.%]="'100'" [style.text-align]="'right'" autocomplete="off" [(ngModel)]="cell.value"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 26)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgTI === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_ApprovedPriceTI" [binding]="'approvedPriceTI'"
                [header]="'成立価格\n\nちば'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceTI">
                  </app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" #txt_approvedPriceTI [(ngModel)]="cell.value" [maxlength]="6" autocomplete="off"
                    [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub [restrict]="'[0-9]'"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 27)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgTI === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [isReadOnly]="true" [width]="100" id="col_DeliveryLeadTimeTypeTI"
                [binding]="'deliveryLeadTimeTypeNameTI'" [header]="'配達リード\n区分\nちば'" [multiLine]="true">
              </wj-flex-grid-column>

              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_SupplyPiceSA" [binding]="'thisTimeSupplyPriceSA'"
                [header]="'供給価格\n\nさいたま'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceSA">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_thisTimeCostPriceSA"
                [binding]="'thisTimeCostPriceSA'" [header]="'仕入価格\n\nさいたま'" [multiLine]="true" [isReadOnly]="true"
                [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceSA">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumSA" [binding]="'approvedNumSA'"
                [header]="'セット企画数量\n\nさいたま'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                  <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumSA"></app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3" #txt_approvedNumSA
                    [style.width.%]="'100'" [style.text-align]="'right'" autocomplete="off" [(ngModel)]="cell.value"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 31)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgSA === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_ApprovedPriceSA" [binding]="'approvedPriceSA'"
                [header]="'成立価格\n\nさいたま'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceSA">
                  </app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" #txt_approvedPriceSA [(ngModel)]="cell.value" [maxlength]="6" autocomplete="off"
                    [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub [restrict]="'[0-9]'"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 32)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgSA === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [isReadOnly]="true" [width]="100" id="col_DeliveryLeadTimeTypeSA"
                [binding]="'deliveryLeadTimeTypeNameSA'" [header]="'配達リード\n区分\nさいたま'" [multiLine]="true">
              </wj-flex-grid-column>

              <wj-flex-grid-column [minWidth]="5" [width]="80" id="col_SupplyPiceTK" [binding]="'thisTimeSupplyPriceTK'"
                [header]="'供給価格\n\nとうきょう'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceTK">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="80" id="col_thisTimeCostPriceTK"
                [binding]="'thisTimeCostPriceTK'" [header]="'仕入価格\n\nとうきょう'" [multiLine]="true" [isReadOnly]="true"
                [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceTK">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumTK" [binding]="'approvedNumTK'"
                [header]="'セット企画数量\n\nとうきょう'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                  <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumTK"></app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3" #txt_approvedNumTK
                    [style.width.%]="'100'" [style.text-align]="'right'" autocomplete="off" [(ngModel)]="cell.value"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 36)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgTK === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="80" id="col_ApprovedPriceTK" [binding]="'approvedPriceTK'"
                [header]="'成立価格\n\nとうきょう'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceTK">
                  </app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" #txt_approvedPriceTK [(ngModel)]="cell.value" [maxlength]="6" autocomplete="off"
                    [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub [restrict]="'[0-9]'"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 37)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgTK === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [isReadOnly]="true" [width]="100" id="col_DeliveryLeadTimeTypeTK"
                [binding]="'deliveryLeadTimeTypeNameTK'" [header]="'配達リード\n区分\nとうきょう'" [multiLine]="true">
              </wj-flex-grid-column>

              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_SupplyPiceNA" [binding]="'thisTimeSupplyPriceNA'"
                [header]="'供給価格\n\nながの'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceNA">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_thisTimeCostPriceNA"
                [binding]="'thisTimeCostPriceNA'" [header]="'仕入価格\n\nながの'" [multiLine]="true" [isReadOnly]="true"
                [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceNA">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumNA" [binding]="'approvedNumNA'"
                [header]="'セット企画数量\n\nながの'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                  <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumNA"></app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3" #txt_approvedNumNA
                    [style.width.%]="'100'" [style.text-align]="'right'" autocomplete="off" [(ngModel)]="cell.value"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 41)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgNA === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_ApprovedPriceNA" [binding]="'approvedPriceNA'"
                [header]="'成立価格\n\nながの'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceNA">
                  </app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" #txt_approvedPriceNA [(ngModel)]="cell.value" [maxlength]="6" autocomplete="off"
                    [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub [restrict]="'[0-9]'"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 42)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgNA === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [isReadOnly]="true" [width]="100" id="col_DeliveryLeadTimeTypeNA"
                [binding]="'deliveryLeadTimeTypeNameNA'" [header]="'配達リード\n区分\nながの'" [multiLine]="true">
              </wj-flex-grid-column>

              <wj-flex-grid-column [minWidth]="5" [width]="80" id="col_SupplyPiceNI" [binding]="'thisTimeSupplyPriceNI'"
                [header]="'供給価格\n\nにいがた'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceNI">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="80" id="col_thisTimeCostPriceNI"
                [binding]="'thisTimeCostPriceNI'" [header]="'仕入価格\n\nにいがた'" [multiLine]="true" [isReadOnly]="true"
                [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceNI">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumNI" [binding]="'approvedNumNI'"
                [header]="'セット企画数量\n\nにいがた'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                  <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumNI"></app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3" #txt_approvedNumNI
                    [style.width.%]="'100'" [style.text-align]="'right'" autocomplete="off" [(ngModel)]="cell.value"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 46)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgNI === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="80" id="col_ApprovedPriceNI" [binding]="'approvedPriceNI'"
                [header]="'成立価格\n\nにいがた'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceNI">
                  </app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" #txt_approvedPriceNI [(ngModel)]="cell.value" [maxlength]="6" autocomplete="off"
                    [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub [restrict]="'[0-9]'"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 47)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgNI === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [isReadOnly]="true" [width]="100" id="col_DeliveryLeadTimeTypeNI"
                [binding]="'deliveryLeadTimeTypeNameNI'" [header]="'配達リード\n区分\nにいがた'" [multiLine]="true">
              </wj-flex-grid-column>

              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_SupplyPiceKU" [binding]="'thisTimeSupplyPriceKU'"
                [header]="'供給価格\n\nクルコ'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceKU">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_thisTimeCostPriceKU"
                [binding]="'thisTimeCostPriceKU'" [header]="'仕入価格\n\nクルコ'" [multiLine]="true" [isReadOnly]="true"
                [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceKU">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumKU" [binding]="'approvedNumKU'"
                [header]="'セット企画数量\n\nクルコ'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                  <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumKU"></app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                  <label>{{item.approvedNumKU}}</label>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3" #txt_approvedNumKU
                    [style.width.%]="'100'" [style.text-align]="'right'" autocomplete="off" [(ngModel)]="cell.value"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 51)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgKU === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" id="col_ApprovedPriceKU" [binding]="'approvedPriceKU'"
                [header]="'成立価格\n\nクルコ'" [multiLine]="true" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceKU">
                  </app-comma-format>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" #txt_approvedPriceKU [(ngModel)]="cell.value" [maxlength]="6" autocomplete="off"
                    [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub [restrict]="'[0-9]'"
                    (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 52)"
                    [disabled]="!KYMW1312Model.editLock || !(cell.item.handlingFlgKU === '1')" [tabindex]="0" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [isReadOnly]="true" [width]="100" id="col_DeliveryLeadTimeTypeKU"
                [binding]="'deliveryLeadTimeTypeNameKU'" [header]="'配達リード\n区分\nクルコ'" [multiLine]="true">
              </wj-flex-grid-column>
            </wj-flex-grid>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Regist" class='btn-primary' [disabled]="KYMW1312Model.disabledRegist || !KYMW1312Model.isGroupNormal"
            (click)="eventRegist_CLICKHandler($event)" [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClose_CLICKHandler($event)"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>